<template>
  <div class="credits">
    <section class="headtop">
      <div class="container">
        <div class="col-sm-9 right-border">
          <h1>
            Previous Interventions
          </h1>
          <br>
          <RunButtons />
        </div>
        <div class="col-sm-3">
          <CovidStatus />
        </div>
        <div class="clearfix" />
      </div>
    </section>

    <div class="container">
      <section class="widget policies-container table-responsive">
        <table class="table table-striped">
          <thead class="thead-dark">
            <tr>
              <th>Input</th>
              <template v-for="step of steps">
                <th
                  :key="step"
                  class="text-center"
                >
                  {{ `step #${step}` }}
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-for="input of currentRun.getInputVariables()">
              <tr :key="input.name">
                <td>
                  {{ input.label }}
                </td>
                <template v-for="step of steps">
                  <td
                    :key="step"
                    class="text-center"
                  >
                    <template v-if="input.values[`time${step}`] === true">
                      x
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                </template>
              </tr>
            </template>
          </tbody>
        </table>
      </section>
    </div>
  </div>
</template>

<script>
import CovidStatus from "../components/CovidStatus";
import RunButtons from "../components/RunButtons";
import data from "../services/data";
import "bootstrap";

export default {
  components: {
    CovidStatus,
    RunButtons
  },
  data() {
    return {
      steps: [],
      inputs: data.inputs,
      inputCategories: data.inputCategories,
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      runStages: data.runStages,
      running: false
    };
  },
  created() {
    const currentStep = this.currentRun.getCurrentStep();
    for (let i = 1; i < currentStep; i += 1) {
      this.steps.push(i);
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss">
.currentRun {
  border-width: 0 2px;
  border-style: solid;
  border-color: #009482;
}
.top.currentRun {
  border-width: 2px 2px 0 2px;
}
.bottom {
  font-weight: bold;
  font-size: 0.8em;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 10px;
}
.bottom.currentRun {
  border-width: 0 2px 2px 2px;
}
.top h4 {
  padding-bottom: 8px;
}
.top p {
  font-size: 0.95em;
}
.top {
  padding-top: 25px;
  padding-bottom: 18px;
  font-weight: 400;
  font-size: 14px;
}
.widget.policies-container {
  background: none;
}
.widget.policies-container .white-background,
.widget.policies-container .white-background-ifcurrent.currentRun {
  background-color: #fff;
}
</style>
